"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../../hooks");
const ButtonContainer_1 = require("../ButtonContainer");
exports.EmailCanvasBlockDevDebugButton = () => {
    const context = hooks_1.useEmailCanvasBlockDetailContext();
    return (react_1.default.createElement(ButtonContainer_1.ButtonContainer, null,
        react_1.default.createElement(react_2.OsmosysButtonBlockToolbar, { osysName: "EmailCanvasBlockDevDebugButton", tooltip: "Debug", osysIcon: "html", onClick: () => {
                console.log({ context });
            } })));
};
//# sourceMappingURL=DevDebugButton.js.map